import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

import './ConfirmDeletePopup.css';

export const CONFIRM_DELETE_LINE1 = 'Are you sure you want to delete?';
export const CONFIRM_DELETE_LINE2 = 'This action cannot be undone';

//Shared delete-confirmation gate, mounted next to any component with a Delete button.
//request(action) checks the 'Confirm deletion' setting each time: when it is on the warning
//is shown and the action runs only on Yes; when it is off (or unreadable -- older servers
//without the servlet keep their old behaviour) the action runs immediately.
class ConfirmDeletePopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false
        };

        this.pendingAction = null;
    }

    request = (action) => {

        return fetch('get_confirm_delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then(data => data && data[0] && '1' === data[0].value)
        .catch(() => false)
        .then((confirmationNeeded) => {
            if (confirmationNeeded)
            {
                this.pendingAction = action;
                this.setState({ showPopup: true });
            }
            else
            {
                action();
            }
        });
    }

    handleYes = () => {
        const action = this.pendingAction;

        this.pendingAction = null;
        this.setState({ showPopup: false });

        if (action)
        {
            action();
        }
    }

    handleNo = () => {
        this.pendingAction = null;
        this.setState({ showPopup: false });
    }

    render() {
        return (
            <Modal
              className="confirmDeleteRoot"
              backdropClassName="confirmDeleteBackdrop"
              dialogClassName="confirmDeleteModal"
              show={this.state.showPopup}
              onHide={this.handleNo}
              backdrop="static"
              animation={false}
              centered
            >
            <Modal.Header>
                <Modal.Title><h3>Confirm deletion</h3></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>{CONFIRM_DELETE_LINE1}</div>
                <div>{CONFIRM_DELETE_LINE2}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={this.handleYes}>Yes</Button>
                <Button onClick={this.handleNo}>No</Button>
            </Modal.Footer>
            </Modal>
        )
    }
}

export default ConfirmDeletePopup;
